export const categories = [
  {title: 'Psykosociala fenomen', id:0, topColor: '#D68184', bottomColor: '#CE606B'},
  {title: 'Illasinnad retorik', id:1, topColor: '#A99437', bottomColor: '#958A54'},
  {title: 'Falska identiteter', id:2, topColor: '#8DBCCC', bottomColor: '#68ABBE'},
  {title: 'Symbolhandlingar', id:3, topColor: '#908293', bottomColor: '#837C84'},
]

export const cards = [
  {
    title: 'bandwagoneffekt',
    categoryId: 0,
    cardText: 'Personer som upplever sig ha samma åsikt som majoriteten är mer benägna att dela med sig av sin åsikt. Botar och troll kan användas för att ge fler gilla-markeringar, kommentarer eller delningar på sociala medier för att ge intrycket av att vissa åsikter är mer populära än de egentligen är.',
    imgFront: 'img3.jpg',
    imgBack: 'img4.jpg',
    exampleFront: 'img5.jpg',
    exampleBack: 'img6.jpg',
    pattern: 'circle_bandwagon.png'
  },
  {
    title: 'tystnadsspiralen',
    categoryId: 0,
    cardText: 'Personer som upplever sig vara i minoritet är mindre benägna att dela med sig av sin åsikt. Intrycket av att man är i minoritet för att man inte vill eller vågar uttala sig i en fråga. Detta spelar på vår rädsla för att hamna utanför eller pekas ut som konstig.',
    imgFront: 'img7.jpg',
    imgBack: 'img8.jpg',
    exampleFront: 'img9.jpg',
    exampleBack: 'img10.jpg',
    pattern: 'circle_tystnadsspiralen.png'
  },
  {
    title: 'filterbubbla',
    categoryId: 0,
    cardText: 'Naturliga grupperingar, på eller utanför internet, där man kommunicerar med andra som delar samma åsikter och uppfattningar. De som ingår i gruppen exponeras sällan för annorlunda åsikter. På nätet kan detta utnyttjas för att sprida riktad information till specifika grupper.',
    imgFront: 'img11.jpg',
    imgBack: 'img12.jpg',
    exampleFront: 'img13.jpg',
    exampleBack: 'img14.jpg',
    pattern: 'circle_filterbubbla.png'
  },
  {
    title: 'dark ads',
    categoryId: 0,
    cardText: 'Annonser som är skräddarsydda och synliga för en snäv målgrupp, men osynliga för andra, t. ex forskare eller journalister. Lämpliga mottagare identifieras genom data från bland annat sociala medier och utnyttjas för att sprida vinklad information. För den som nås av budskapet framstår det som att informationen är synlig för alla.',
    imgFront: 'img15.jpg',
    imgBack: 'img16.jpg',
    exampleFront: 'img17.jpg',
    exampleBack: 'img18.jpg',
    pattern: 'circle_darkads.png'
  },
  {
    title: 'gish gallop',
    categoryId: 1,
    cardText: 'Motparten översvämmas med en flod av argument, fakta och källor, varav många är falska eller orelaterade till frågan. För den som börjar bemöta störtfloden är spelet förlorat, då diskussionen kommer att handla om något annat än sakfrågan.',
    imgFront: 'img19.jpg',
    imgBack: 'img20.jpg',
    exampleFront: 'djurforsok.jpg',
    exampleBack: 'img22.jpg',
    pattern: 'circle_gishgallop.png'
  },
  {
    title: 'personangrepp',
    categoryId: 1,
    cardText: 'Att attackera, förtala och förlöjliga personen bakom ett argument eller personens handlingar, istället för att kritisera argumentet i sig. Denna metod används ofta i syfte att tysta ner, hindra och avskräcka andra från att delta i diskussionen.',
    imgFront: 'img23.jpg',
    imgBack: 'img24.jpg',
    exampleFront: 'img25.jpg',
    exampleBack: 'img26.jpg',
    pattern: 'circle_personangrepp.png'
  },
  {
    title: 'halmgubbar',
    categoryId: 1,
    cardText: 'Att medvetet förvränga motståndarens argument och ståndpunkter och sedan argumentera mot dessa istället för motståndarens faktiska åsikter. Motståndaren tvingas lägga ner energi på att förklara vad som egentligen menas samtidigt som fokus från sakfrågan förskjuts.',
    imgFront: 'img27.jpg',
    imgBack: 'img28.jpg',
    exampleFront: 'img29.jpg',
    exampleBack: 'img30.jpg',
    pattern: 'circle_halmgubbar.png'
  },
  {
    
    title: 'whataboutism',
    categoryId: 1,
    cardText: 'Att ta fokus från ett argument genom att belysa liknande fenomen som inte fått lika mycket uppmärksamhet, men som inte riktigt är relevant i frågan. Ofta yttrar sig detta i att man jämför något som anses vara fel med något annat ännu sämre, och på så sätt ta fokus från sakfrågan.',
    imgFront: 'img31.jpg',
    imgBack: 'img32.jpg',
    exampleFront: 'img33.jpg',
    exampleBack: 'img34.jpg',
    pattern: 'circle_whataboutism.png'
  },
  {
    title: 'lockfåglar',
    categoryId: 2,
    cardText: 'En person som ger intrycket av att vara fristående men som i själva verket samarbetar med eller tar emot betalning av någon annan. Denna metod används ibland för att skriva positiva produktrecensioner för webbutiker och för att ge trovärdighet till en person eller ett budskap.',
    imgFront: 'img35.jpg',
    imgBack: 'img36.jpg',
    exampleFront: 'img37.jpg',
    exampleBack: 'img38.jpg',
    pattern: 'circle_lockfåglar.png'
  },
  {
    title: 'falsk media',
    categoryId: 2,
    cardText: 'Desinformation kan spridas genom förfalskade nyhetssidor som efterliknar äkta sådana. På internet kan man exempelvis skapa en falsk webbplats som är i stort sett identisk med en riktig webbplats, men med annat innehåll.',
    imgFront: 'img39.jpg',
    imgBack: 'img40.jpg',
    exampleFront: 'img41.jpg',
    exampleBack: 'img42.jpg',
    pattern: 'circle_falskmedia.png'
  },
  {
    title: 'bot',
    categoryId: 2,
    cardText: 'Ett datorprogram som utför automatiserade uppgifter och till exempel delar vissa typer av information på sociala medier. Inom informationspåverkan kan botar exempelvis användas för att förstärka utvalda budskap, sprida desinformation och för att kartlägga andra, mänskliga användare. ',
    imgFront: 'img43.jpg',
    imgBack: 'img44.jpg',
    exampleFront: 'img45.jpg',
    exampleBack: 'img46.jpg',
    pattern: 'circle_bot.png'
  },
  {
    title: 'trollfabrik',
    categoryId: 2,
    cardText: 'Ett företag där de anställda skapar och driver falska identiteter på sociala medier. Personer skriver inlägg och kommenterar andras inlägg för att skpa opinion för vissa åsikter. Ofta försöker de provocera fram känslomässiga svar och gräl som är destruktiva för diskussionsklimatet.',
    imgFront: 'img47.jpg',
    imgBack: 'img48.jpg',
    exampleFront: 'img49.jpg',
    exampleBack: 'img50.jpg',
    pattern: 'circle_trollfabrik.png'
  },
  {
    title: 'hackning',
    categoryId: 3,
    cardText: 'Detta innebär obehörig åtkomst till en dator eller ett nätverk, vilket i sig är ett brott. Inom informationspåverkan är ibland det egentliga målet att sprida misstänksamhet om att ett system är exponerat eller osäkert, vilket underminerar förtroendet för systemet ifråga eller organisationen bakom.',
    imgFront: 'img51.jpg',
    imgBack: 'img52.jpg',
    exampleFront: 'img53.jpg',
    exampleBack: 'img54.jpg',
    pattern: 'circle_hackning.png'
  },
  {
    title: 'astroturfing',
    categoryId: 3,
    cardText: 'Riktiga demonstrationer används för att uttrycka stöd för en viss politisk fråga och är en viktig del i vår demokrati. Denna metod utnyttjar känslan av äkthet och folkligt engagemang, som vi människor lätt dras med i, genom att rigga en demonstration och ge ett falskt intryck av stöd för en viss fråga på gräsrotsnivå.',
    imgFront: 'img55.jpg',
    imgBack: 'img56.jpg',
    exampleFront: 'img57.jpg',
    exampleBack: 'img58.jpg',
    pattern: 'circle_astroturfing.png'
  },
  {
    title: 'false flags',
    categoryId: 3,
    cardText: 'Detta var ursprungligen en sjökrigsterm där en aktör seglade under en annan flagga än sin egen. I modern tappning beskriver termen specialoperationer som lagts upp så att det framstår som om de utförts av en viss aktör snarare än den som faktiskt planerade och utförde den.',
    imgFront: 'img59.jpg',
    imgBack: 'img60.jpg',
    exampleFront: 'img61.jpg',
    exampleBack: 'img62.jpg',
    pattern: 'circle_falseflags.png'
  },
]